import React from 'react'
import { Badge, Table, Td, Th, Tr } from '@/shared/ui'
import { Pagination } from '@/shared/ui/Pagination'
import { formatMoneyFromCents } from '@/shared/i18n/money'
import { listMyRevsharePayoutsPaged } from '../services/revsharePayoutService'
import { monthStartDateToLabel } from '../utils/month'

function iso(v?: string | null) {
  return v ? new Date(v).toLocaleString() : '-'
}

export default function RevshareMyPayoutsPanel() {
  const [items, setItems] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [total, setTotal] = React.useState(0)
  const [page, setPage] = React.useState(1)
  const pageSize = 25

  React.useEffect(() => {
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const { rows, total } = await listMyRevsharePayoutsPaged(page, pageSize)
        setItems(rows)
        setTotal(total)
      } catch (e: any) {
        setError(e?.message || 'Falha ao carregar recebimentos')
        setItems([])
        setTotal(0)
      } finally {
        setLoading(false)
      }
    })()
  }, [page])

  return (
    <div className="space-y-4">
      <div className="text-base font-medium">Recebimentos</div>
      {error && (
        <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">
          {error}
        </div>
      )}
      {loading ? (
        <div className="text-sm text-foreground/70">Carregando...</div>
      ) : (
        <>
          <Table>
            <thead>
              <Tr>
                <Th>Data</Th>
                <Th>Competencia</Th>
                <Th>Status</Th>
                <Th>Valor</Th>
                <Th>Agendado</Th>
                <Th>Pago em</Th>
              </Tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <Tr key={p.id}>
                  <Td>{iso(p.created_at)}</Td>
                  <Td>{monthStartDateToLabel(p.competence_month)}</Td>
                  <Td>
                    <Badge variant="soft" className="capitalize">
                      {p.status}
                    </Badge>
                  </Td>
                  <Td className="font-mono">{formatMoneyFromCents(p.amount_cents, p.currency || 'BRL')}</Td>
                  <Td>{iso(p.scheduled_for)}</Td>
                  <Td>{iso(p.paid_at)}</Td>
                </Tr>
              ))}
              {items.length === 0 && (
                <Tr>
                  <Td colSpan={6} className="py-6 text-center text-sm text-foreground/70">
                    Nenhum recebimento ainda.
                  </Td>
                </Tr>
              )}
            </tbody>
          </Table>
          <div className="flex justify-end">
            <Pagination page={page} total={Math.max(1, Math.ceil(total / pageSize))} onChange={setPage} />
          </div>
        </>
      )}
    </div>
  )
}

